const constants = {
    web_general: "Webchat non-GPT backup",
    voice_general: "Voice bot non-GPT backup",
    GEN_WEB: "Webchat non-GPT backup",
    GEN_VOICE: "Voice bot non-GPT backup",
    OUTBOUND: "Outbound",
    OUTBOUND_SMS: "Outbound SMS",
   
   
    // Twilio Official A2P 10DLC Use Case Values (API enum values)
    // Documentation: https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/standard-use-cases
    USE_CASE_OPTIONS: [
      { key: '2fa', text: 'Two-Factor Authentication (2FA)', value: '2FA' },
      { key: 'account_notification', text: 'Account Notifications', value: 'ACCOUNT_NOTIFICATION' },
      { key: 'customer_care', text: 'Customer Care & Support', value: 'CUSTOMER_CARE' },
      { key: 'delivery_notification', text: 'Delivery Notifications', value: 'DELIVERY_NOTIFICATION' },
      { key: 'fraud_alert', text: 'Fraud Alert Messaging', value: 'FRAUD_ALERT' },
      { key: 'higher_education', text: 'Higher Education', value: 'HIGHER_EDUCATION' },
      { key: 'low_volume', text: 'Low Volume Mixed', value: 'LOW_VOLUME' },
      { key: 'marketing', text: 'Marketing', value: 'MARKETING' },
      { key: 'mixed', text: 'Mixed Use Case', value: 'MIXED' },
      { key: 'polling_voting', text: 'Polling and Voting', value: 'POLLING_VOTING' },
      { key: 'public_service_announcement', text: 'Public Service Announcements', value: 'PUBLIC_SERVICE_ANNOUNCEMENT' },
      { key: 'security_alert', text: 'Security Alerts', value: 'SECURITY_ALERT' },
    ],

  // Twilio Voice Integrity use case values (different from A2P — voice product only)
  VOICE_INTEGRITY_USE_CASE_OPTIONS: [
    { key: 'outbound_dialer', text: 'Outbound Dialer', value: 'Outbound_Dialer' },
    { key: 'telemarketing', text: 'Telemarketing', value: 'Telemarketing' },
    { key: 'marketing_events', text: 'Marketing Events', value: 'Marketing_Events' },
    { key: 'lead_generation', text: 'Lead Generation', value: 'Lead_Generation' },
    { key: 'lead_management', text: 'Lead Management', value: 'Lead_Management' },
    { key: 'lead_nurturing', text: 'Lead Nurturing', value: 'Lead_Nurturing' },
    { key: 'lead_alerts', text: 'Lead Alerts', value: 'Lead_Alerts' },
    { key: 'customer_support', text: 'Customer Support', value: 'Customer_Support' },
    { key: 'automated_support', text: 'Automated Support', value: 'Automated_Support' },
    { key: 'appointment_reminders', text: 'Appointment Reminders', value: 'Appointment_Reminders' },
    { key: 'appointment_scheduling', text: 'Appointment Scheduling', value: 'Appointment_SchedulingDE' },
    { key: 'click_to_call', text: 'Click to Call', value: 'Click_to_Call' },
    { key: 'call_tracking', text: 'Call Tracking', value: 'Call_Tracking' },
    { key: 'intelligent_routing', text: 'Intelligent Routing', value: 'Intelligent_Routing' },
    { key: 'employee_notifications', text: 'Employee Notifications', value: 'Employee_Notifications' },
    { key: 'delivery_notifications', text: 'Delivery Notifications', value: 'Delivery_Notifications' },
    { key: 'order_notifications', text: 'Order Notifications', value: 'Order_Notifications' },
    { key: 'service_alerts', text: 'Service Alerts', value: 'Service_Alerts' },
    { key: 'fraud_alerts', text: 'Fraud Alerts', value: 'Fraud_Alerts' },
    { key: 'mass_alerts', text: 'Mass Alerts', value: 'Mass_Alerts' },
    { key: 'emergency_notifications', text: 'Emergency Notifications', value: 'Emergency_Notifications' },
    { key: 'survey_research', text: 'Survey / Research', value: 'Survey/Research' },
    { key: 'identify_verification', text: 'Identity Verification', value: 'Verification' },
    { key: 'phone_system', text: 'Phone System', value: 'Phone_System' },
    { key: 'self_service', text: 'Self-Service', value: 'Self-Service' },
  ],

  CONSENT_TYPE_OPTIONS: [
    { key: 'web_form_with_opt_in', text: 'Web form with opt-in', value: 'web_form_with_opt_in' },
    { key: 'sms_opt_in', text: 'SMS opt-in', value: 'sms_opt_in' },
    { key: 'prior_customer_relationship', text: 'Prior customer relationship', value: 'prior_customer_relationship' },
    { key: 'written_agreement', text: 'Written agreement', value: 'written_agreement' },
    { key: 'inquired_via_inbound_call', text: 'Inquired via inbound call', value: 'inquired_via_inbound_call' },
    { key: 'other', text: 'Other', value: 'other' }
  ] 


   };
   export default constants;
   